import { StorageCostService, type InitStorageCostParams } from '@meitu/xdesign-widgets/dist/storageCost';
import { VipLevel } from '@meitu/xdesign-widgets/dist/types/userInfo';
import { statTrack } from '@/utils/mtstat';

type PPTUserInfo = {
  id?: number;
  is_vip?: boolean;
  vip_level?: number;
  vip_days?: number;
  vip_end_time?: number;
};

type TriggerGenerateStorageAlertParams = {
  userInfo?: PPTUserInfo;
  onOpenVipModal?: InitStorageCostParams['onOpenVipModal'];
  onOpenSpaceManager?: InitStorageCostParams['onOpenSpaceManager'];
};

const storageCostService = new StorageCostService();
let isChecking = false;

export const triggerGenerateStorageAlert = ({
  userInfo,
  onOpenVipModal,
  onOpenSpaceManager,
}: TriggerGenerateStorageAlertParams) => {
  if (!userInfo?.id || isChecking) {
    return;
  }

  isChecking = true;
  storageCostService
    .init({
      pageMode: 'aigc',
      userInfo: {
        isVip: Boolean(userInfo.is_vip),
        vipLevel: (userInfo.vip_level ?? 0) as VipLevel,
        vipDays: userInfo.vip_days ?? 0,
        vipEndTime: userInfo.vip_end_time ?? -1,
      },
      onOpenVipModal,
      onOpenSpaceManager,
      onTrack: statTrack,
    })
    .catch((error) => {
      console.warn('===[storage-cost] live-ppt init failed', error);
    })
    .finally(() => {
      isChecking = false;
    });
};
